import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1C1917] text-[#A89F91] py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div>
            <h3 className="font-['Cormorant_Garamond'] text-2xl sm:text-3xl text-[#FCFBF9] font-medium mb-4">
              Heirloom Stories Studio
            </h3>
            <p className="text-sm leading-relaxed opacity-80">
              Stories meant to last.
            </p>
          </div>
          <div>
            <p className="overline text-[#A89F91] mb-4">Navigate</p>
            <div className="space-y-3">
              {[
                { to: '/how-it-works', label: 'How It Works' },
                { to: '/packages', label: 'Packages' },
                { to: '/about', label: 'About' },
                { to: '/contact', label: 'Contact' },
              ].map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm hover:text-[#FCFBF9] transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <p className="overline text-[#A89F91] mb-4">Connect</p>
            <p className="text-sm leading-relaxed opacity-80 mb-4">
              Ready to preserve what matters most?
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-block text-sm border border-[#A89F91] text-[#FCFBF9] px-6 py-2.5 hover:bg-[#FCFBF9] hover:text-[#1C1917] transition-all duration-300"
            >
              Begin Your Story
            </Link>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#333] text-xs opacity-60 text-center">
          <span>&copy; {new Date().getFullYear()} Heirloom Stories Studio. All rights reserved.</span>
          <span className="mx-2">&middot;</span>
          <Link to="/ops/login" className="hover:text-[#FCFBF9] transition-colors duration-300">Staff Login</Link>
        </div>
      </div>
    </footer>
  );
}
